<template>
  <div v-if="visible" class="pay-mask" role="dialog" aria-modal="true" aria-label="支付宝扫码支付">
    <div class="pay-mask__bg" @click="onClose" />
    <div class="pay-panel panel" @click.stop>
      <button type="button" class="pay-panel__close" aria-label="关闭" @click="onClose">×</button>
      <h2 class="pay-panel__title">{{ title || '支付宝扫码支付' }}</h2>
      <p class="pay-panel__hint">
        请在 <span class="mono">{{ countdownText }}</span> 内使用支付宝扫码完成支付
      </p>
      <div class="pay-panel__price">¥{{ priceMain }}</div>
      <div class="pay-panel__qr">
        <img v-if="qrImageSrc && !qrLoading" :src="qrImageSrc" alt="支付二维码" @error="onQrError" />
        <div v-else class="pay-panel__qr-fallback">
          {{ qrError ? '二维码生成失败' : '正在生成二维码…' }}
        </div>
      </div>
      <p class="pay-panel__tip">支付成功后积分将自动到账，可返回消耗明细查看余额</p>
    </div>
  </div>
</template>

<script>
import { generatePayQrDataUrl } from '../utils/payQrCode'

export default {
  name: 'PayQrModal',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    priceMain: { type: String, default: '0' },
    qrCode: { type: String, default: '' },
    expireSeconds: { type: Number, default: 900 }
  },
  data() {
    return {
      remainSec: 0,
      timerId: null,
      qrError: false,
      qrImageSrc: '',
      qrLoading: false
    }
  },
  computed: {
    countdownText() {
      const s = Math.max(0, this.remainSec)
      const m = Math.floor(s / 60)
      const sec = s % 60
      const pad = n => String(n).padStart(2, '0')
      return `${pad(m)}:${pad(sec)}`
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(v) {
        if (v) {
          this.startCountdown()
          this.loadQr()
        } else {
          this.stopCountdown()
        }
      }
    },
    qrCode() {
      if (this.visible) this.loadQr()
    }
  },
  beforeDestroy() {
    this.stopCountdown()
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    startCountdown() {
      this.stopCountdown()
      this.remainSec = Math.max(0, Number(this.expireSeconds) || 900)
      this.timerId = window.setInterval(() => {
        if (this.remainSec <= 0) {
          this.stopCountdown()
          this.$emit('expired')
          return
        }
        this.remainSec -= 1
      }, 1000)
    },
    stopCountdown() {
      if (this.timerId != null) {
        clearInterval(this.timerId)
        this.timerId = null
      }
    },
    async loadQr() {
      this.qrError = false
      this.qrImageSrc = ''
      if (!this.qrCode) return
      this.qrLoading = true
      try {
        this.qrImageSrc = await generatePayQrDataUrl(this.qrCode, { width: 220 })
      } catch (e) {
        this.qrError = true
      } finally {
        this.qrLoading = false
      }
    },
    onQrError() {
      this.qrError = true
      this.qrImageSrc = ''
    }
  }
}
</script>

<style scoped>
.pay-mask {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.pay-mask__bg {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.72);
  backdrop-filter: blur(6px);
}
.pay-panel {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 400px;
  padding: 28px 24px 22px;
  text-align: center;
}
.pay-panel__close {
  position: absolute;
  right: 12px;
  top: 10px;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: var(--muted);
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}
.pay-panel__close:hover {
  color: var(--text);
  background: var(--accent-dim);
}
.pay-panel__title {
  margin: 0 28px 10px;
  font-size: 16px;
  font-weight: 700;
}
.pay-panel__hint {
  margin: 0 0 14px;
  font-size: 13px;
  color: var(--muted);
}
.pay-panel__price {
  font-size: 32px;
  font-weight: 800;
  letter-spacing: -0.03em;
  color: var(--accent);
  margin-bottom: 18px;
}
.pay-panel__qr {
  width: 228px;
  height: 228px;
  margin: 0 auto;
  padding: 12px;
  border-radius: 14px;
  background: #fff;
  box-sizing: border-box;
}
.pay-panel__qr img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
.pay-panel__qr-fallback {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  font-size: 12px;
}
.pay-panel__tip {
  margin: 16px 0 0;
  font-size: 12px;
  color: var(--muted);
  line-height: 1.5;
}
</style>
